import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import Footer from '../components/Footer'; // ✅ reuse the same footer
import { appNavigation, urlMap } from '../../utils';

class RecoverPassword extends Component {
  state = {
    email: '',
    message: '',
    error: ''
  };

  handleChange = (e) => {
    this.setState({ email: e.target.value, message: '', error: '' });
  }

  handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(urlMap.recover, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: this.state.email })
      });

      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.message || 'Failed to send recovery email');
      }

      this.setState({
        message: 'A recovery email has been sent if the address exists.',
        error: ''
      });
    } catch (err) {
      this.setState({
        message: '',
        error: err.message
      });
    }
  }

  render() {
    return (
      <div className="login-page">{/* same outer layout as Login/Register */}
        <div className="recover-wrapper">
          <form className="recover-form" onSubmit={this.handleSubmit}>
            <h2>Password Recovery</h2>
            <p className="subtitle">Enter your email to reset your password</p>

            <input
              type="email"
              name="email"
              placeholder="Your email"
              value={this.state.email}
              onChange={this.handleChange}
              required
            />

            <button type="submit">Send Reset Link</button>

            {this.state.message && <p className="success">{this.state.message}</p>}
            {this.state.error && <p className="error">{this.state.error}</p>}

            <p className="footer-link">
              <Link to={appNavigation.login}>← Back to Login</Link>
            </p>
          </form>
        </div>

        {/* ✅ Global footer at the bottom */}
        <Footer />
      </div>
    );
  }
}

export default RecoverPassword;
